module.exports = __webpack_public_path__ + "img/5.50834565.png";